import React from "react";

export function OzonFilterToggle({
                                     name,
                                     value,
                                     onChange,
                                 }: {
    name: string;
    value: boolean;
    onChange: (v: boolean) => void;
}) {
    return (
        <div className="supplies-filter-row">
            <div className="user-type-selector">
                <label className={`user-type-label ${!value ? "active" : ""}`}>
                    <input
                        className="hidden-radio"
                        type="radio"
                        name={name}
                        value="false"
                        checked={!value}
                        onChange={(e) => onChange(e.target.value === "true")}
                    />
                    WB
                </label>
                <label className={`user-type-label ${value ? "active" : ""}`}>
                    <input
                        className="hidden-radio"
                        type="radio"
                        name={name}
                        value="true"
                        checked={value}
                        onChange={(e) => onChange(e.target.value === "true")}
                    />
                    OZON / ЯМ / ТК
                </label>
            </div>
        </div>
    );
}
